// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavLinks_nav__xzS6i","active":"NavLinks_active__qkB4d","white":"NavLinks_white__2a3q3"};